import React from 'react'
import { TruckIcon, DocumentTextIcon, CurrencyDollarIcon, UserIcon, HashtagIcon } from '@heroicons/react/24/outline'
import { CalendarDays } from 'lucide-react'
import { orderStatusOptions, paymentStatusOptions } from './constants/statusOptions'
import { SearchQuery } from './filter/SearchQuery'
import { SelectFilter } from './filter/SelectFilter'
import { DateFilter } from '@/containers/billing/register/billingFilters/filter/DateFilter'
import { RangeFilter } from './filter/RangeFilter'
import { usePurchaseOrderFilters } from './hooks/usePurchaseOrderFilters'
import { useFilterOptions } from '../hooks/useFilterOptions'
import { SelectionSummary } from './SelectionSummary'

export const FiltersRow: React.FC = () => {
  // Use the nuqs-based filter hook
  const {
    filters,
    updateSearch,
    updateIssueDateFrom,
    updateIssueDateTo,
    updateAmountFrom,
    updateAmountTo,
    updateProductTotalFrom,
    updateProductTotalTo,
    updateOrderStatus,
    updatePaymentStatus,
    updateClientId,
    clearAllFilters,
    hasActiveFilters,
  } = usePurchaseOrderFilters()

  // Get filter options from API
  const { 
    clientOptions,
    isLoading 
  } = useFilterOptions()

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <div className="flex-1 min-w-[220px]">
            <SearchQuery
              searchQuery={filters.search}
              onSearchChange={updateSearch}
              placeholder="Buscar por No. orden de compra..."
            />
          </div>
          <SelectFilter
            title="Cliente"
            placeholder="Buscar cliente..."
            activeSelections={filters.clientId}
            onSelectionsChange={updateClientId}
            selectionOptions={clientOptions}
            searchActive={true}
            icon={<UserIcon className="h-4 w-4" />}
          />
          <SelectFilter
            title="Estado de la orden"
            placeholder="Buscar estado..."
            activeSelections={filters.orderStatus}
            onSelectionsChange={updateOrderStatus}
            selectionOptions={orderStatusOptions}
            searchActive={false}
            icon={<DocumentTextIcon className="h-4 w-4" />}
          />
          <SelectFilter
            title="Estado del pago"
            placeholder="Buscar estado..."
            activeSelections={filters.paymentStatus}
            onSelectionsChange={updatePaymentStatus}
            selectionOptions={paymentStatusOptions}
            searchActive={false}
            icon={<CurrencyDollarIcon className="h-4 w-4" />}
          />
          <RangeFilter
            title="Importe"
            placeholder="Seleccionar importe..."
            valueFrom={filters.amountFrom}
            valueTo={filters.amountTo}
            onValueFromChange={updateAmountFrom}
            onValueToChange={updateAmountTo}
            icon={<CurrencyDollarIcon className="h-4 w-4" />}
            currency={true}
          />
          <RangeFilter
            title="Total de productos"
            placeholder="Seleccionar cantidad..."
            valueFrom={filters.productTotalFrom}
            valueTo={filters.productTotalTo}
            onValueFromChange={updateProductTotalFrom}
            onValueToChange={updateProductTotalTo}
            icon={<HashtagIcon className="h-4 w-4" />}
            currency={false}
          />
          <DateFilter
            dateFrom={filters.issueDateFrom}
            dateTo={filters.issueDateTo}
            selectedDateType={''}
            onDateRangeChange={(from, to) => {
              updateIssueDateFrom(from || '')
              updateIssueDateTo(to || '')
            }}
            onDateTypeChange={() => {}}
            hideDateTypeSelect
          />
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            orderStatus={filters.orderStatus}
            setOrderStatus={updateOrderStatus}
            orderStatusOptions={orderStatusOptions}
            paymentStatus={filters.paymentStatus}
            setPaymentStatus={updatePaymentStatus}
            paymentStatusOptions={paymentStatusOptions}
            clientId={filters.clientId}
            setClientId={updateClientId}
            clientOptions={clientOptions}
            issueDateFrom={filters.issueDateFrom}
            setIssueDateFrom={updateIssueDateFrom}
            issueDateTo={filters.issueDateTo}
            setIssueDateTo={updateIssueDateTo}
            amountFrom={filters.amountFrom}
            setAmountFrom={updateAmountFrom}
            amountTo={filters.amountTo}
            setAmountTo={updateAmountTo}
            searchQuery={filters.search}
            setSearchQuery={updateSearch}
            handleClearFilters={handleClearFilters}
          />
        )}
      </div>
    </div>
  )
}
